import { useEffect } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { calculateSugarFromCarbs } from '../../../shared/utils/mealUtils';
import { MealPlansMacrosFormValues } from '../../interfaces/MealPlan';

export const useTotalSugar = (nameIndex: number) => {
  const { control, setValue } = useFormContext<MealPlansMacrosFormValues>();
  const totalCarbs = useWatch({ control, name: `mealPlans.${nameIndex}.total.carbs` });

  useEffect(() => {
    const sugarTotal = calculateSugarFromCarbs(totalCarbs);

    setValue(`mealPlans.${nameIndex}.sugarTotal`, sugarTotal);
  }, [totalCarbs]);
};
